export default __webpack_public_path__ + "static/thin-13b854314d295f36040529fe9f632d58.png";